<script>
import InventoryItemPlaceholder from '@/assets/inventoryItems/InventoryItemPlaceholder'

export default {
  name: 'InventoryItemTypeCell',

  components: {
    InventoryItemPlaceholder
  },

  props: {
    inventoryItems: {
      type: Array,
      required: true
    }
  },

  computed: {

    inventoryItem () {
      return this.inventoryItems[0]
    }

  }

}
</script>

<template>
  <div class="c-view-inventory-item-type-cell">

    <div class="c-view-inventory-item-type-cell-image">
      <inventory-item-placeholder />
    </div>

    <div class="c-view-inventory-item-type-cell-title">
      {{ inventoryItem.name }} x{{ inventoryItems.length }}
    </div>

  </div>
</template>

<style lang="scss">

.c-view-inventory-item-type-cell {
  @include pad-loose;
  @include relative;
  background-color: $very-dark;
}

</style>
